const APP_TITLE = 'Pulinet';
const API_ENDPOINT: () => string = () => {
  if ((window as any).vue$config) return (window as any).vue$config.API_ENDPOINT;
  return '';
};

/**
 * Il valore della voce "Tutti i clienti" nei filtri a tendina.
 *
 * Non puo essere la stringa vuota: element-plus considera `''` come "nessuna selezione" e mostra il
 * placeholder invece dell'etichetta, quindi il filtro sembrava non impostato. Element UI mostrava
 * l'etichetta. Chi filtra traduce questo valore in "nessun filtro".
 */
const TUTTI_I_CLIENTI = 'tutti-i-clienti';

export { APP_TITLE, API_ENDPOINT, TUTTI_I_CLIENTI };
